import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cg_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('cg_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (gem, qty = 1) => {
    setCart(prev => {
      const existing = prev.find(i => i.gemId === gem.id);
      if (existing) {
        return prev.map(i => i.gemId === gem.id ? { ...i, quantity: Math.min(i.quantity + qty, gem.stock_qty) } : i);
      }
      return [...prev, { gemId: gem.id, name: gem.name, price: gem.price_usd, image: gem.primary_image, slug: gem.slug, stock: gem.stock_qty, quantity: qty }];
    });
  };

  const removeFromCart = (gemId) => setCart(prev => prev.filter(i => i.gemId !== gemId));

  const updateQty = (gemId, qty) => {
    if (qty < 1) return removeFromCart(gemId);
    setCart(prev => prev.map(i => i.gemId === gemId ? { ...i, quantity: qty } : i));
  };

  const clearCart = () => setCart([]);

  const total  = cart.reduce((s, i) => s + i.price * i.quantity, 0);
  const count  = cart.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQty, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
